import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate

import p_avanti from "../assets/images/p_avanti.png";

const IpadRegister = () => {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false); // Stato per gestire il modale
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!privacyAccepted) {
            alert("Devi accettare la privacy policy per continuare.");
            return;
        }

        // Prepara i dati da inviare al backend
        const userData = {
            nome: name,
            cognome: surname,
            email: email,
            telefono: phone,
        };

        // Invio dei dati al backend tramite fetch
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });

            const data = await response.json(); // Riceve la risposta JSON con l'ID dell'utente


            if (response.ok) {
                console.log('Registrazione completata con successo!');

                const userId = data.userId; // Ottieni l'ID dell'utente

                // Resetta i campi del form
                setName('');
                setSurname('');
                setEmail('');
                setPhone('');
                setPrivacyAccepted(false);
                console.log(userId);

                // Dopo la registrazione, reindirizza l'utente alla pagina di scelta avatar
                //navigate(`/ipad/avatar?userId=${userId}`);
                navigate(`/ipad/avatar`,  { state: { userId: userId } });

            } else {
                console.log('Errore durante la registrazione');
            }
        } catch (error) {
            console.error('Errore:', error);
            console.log('Errore di connessione');
        }
    };


    const openPrivacyModal = () => {
        setShowPrivacyModal(true);
    };

    const closePrivacyModal = () => {
        setShowPrivacyModal(false);
    };

    return (
        <div className="ipadBG flex flex-col w-full h-full  items-center justify-center relative bg-fixed verflow-hidden" >


            <div className="bg-black p-8 rounded-3xl shadow-md w-[547px] h-[526px] top-[158px] relative opacity-90">

                <form onSubmit={handleSubmit}>

                    {/* Nome */}
                    <div className="mb-4 flex items-center">
                        <label className="w-32 text-xl font-medium text-white">NOME*</label>
                        <input
                            type="text"
                            className="flex-1 block px-3 py-2 border border-gray-300 rounded-md"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Cognome */}
                    <div className="mb-4 flex items-center">
                        <label className="w-32 text-xl font-medium text-white">COGNOME*</label>
                        <input
                            type="text"
                            className="flex-1 block px-3 py-2 border border-gray-300 rounded-md"
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="mb-4 flex items-center">
                        <label className="w-32 text-xl font-medium text-white">E-MAIL*</label>
                        <input
                            type="email"
                            className="flex-1 block px-3 py-2 border border-gray-300 rounded-md"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {/* Telefono */}
                    <div className="mb-6 flex items-center">
                        <label className="w-32 text-xl font-medium text-white">TELEFONO</label>
                        <input
                            type="tel"
                            className="flex-1 block px-3 py-2 border border-gray-300 rounded-md"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>

                    {/* Checkbox per la privacy */}
                    <div className="mb-4 flex items-center">
                        <table width="{100%}">
                            <tbody>
                            <tr>
                                <td width={30} valign="top"><input
                                    type="checkbox"
                                    className="mr-2 transform scale-150"
                                    checked={privacyAccepted}
                                    onChange={(e) => setPrivacyAccepted(e.target.checked)}
                                    required
                                /></td>
                                <td valign="top"><label className="text-sm font-medium text-white italic">Confermo di
                                    aver letto e compreso l’<a href="#" className="underline"
                                                                           onClick={openPrivacyModal}>informativa
                                        privacy.</a></label></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Pulsante di invio come immagine */}
                   
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="w-auto"
                            style={{background: 'none', border: 'none'}}
                        >
                            <img
                                src={p_avanti}  // Percorso dell'immagine del pulsante
                                alt="Invia"
                                className="w-[136px] h-auto" // Imposta una larghezza personalizzata per l'immagine
                            />
                        </button>
                    </div>


                </form>











                {showPrivacyModal && (
                    <div className="fixed inset-0 bg-gray-900  flex justify-center items-center z-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-lg  ">
                            <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
                            <p className="text-sm text-gray-700">
                                Inserisci qui il testo della tua privacy policy. Descrivi come
                                vengono gestiti i dati personali degli utenti e quali sono i
                                loro diritti.
                            </p>
                            <button className="mt-4 text-white px-4 py-2 rounded bg-orange opacity-100 text-sm font-medium" onClick={closePrivacyModal} >CHIUDI</button>
                        </div>
                    </div>
                )}






            </div>
        </div>
    );
};

export default IpadRegister;
